import React, { Fragment, useCallback, useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import VerificationTypeContainer from './VerificationTypeContainer';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_VERIFICATION_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');

  const verificationTypeId = match.params.verificationTypeId && getInt(match.params.verificationTypeId);
  const [canTestVerification, setCanTestVerification] = useState(true);
  const [applicabilityFormulaForTest, setApplicabilityFormulaForTest] = useState(null);

  const handleClickClose = useCallback(() => {
    historyContext.push(`/verificationTypes`);
  }, [historyContext]);

  const handleChangeTitle = useCallback(title => {
    setTitle(title);
  }, []);

  const handleRedirect = useCallback(
    verificationTypeId => {
      historyContext.push(`/verificationTypes/${verificationTypeId}`);
    },
    [historyContext]
  );

  useEffect(() => {
    if (applicabilityFormulaForTest) setCanTestVerification(true);
    else setCanTestVerification(false);
  }, [applicabilityFormulaForTest, setCanTestVerification]);

  const handleVerificationTest = () => {
    if (canTestVerification) window.open(window.location.href + `/test`, '_blank');
  };

  const handleApplicabilityFormulaForTestChanged = useCallback(applicabilityFormulaForTest => {
    setApplicabilityFormulaForTest(applicabilityFormulaForTest);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header
          title={title}
          onVerificationTest={handleVerificationTest}
          canTestVerification={canTestVerification}
          id={verificationTypeId}
        />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_VERIFICATION_TYPES} withForbiddenPage={false}>
          <HeaderLinks
            onClickClose={handleClickClose}
            onVerificationTest={handleVerificationTest}
            canTestVerification={canTestVerification}
            id={verificationTypeId}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_VERIFICATION_TYPES}>
        <VerificationTypeContainer
          verificationTypeId={verificationTypeId}
          onClickClose={handleClickClose}
          onChangeTitle={handleChangeTitle}
          openVerificationTest={false}
          onRedirect={handleRedirect}
          onApplicabilityFormulaForTestChanged={handleApplicabilityFormulaForTestChanged}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
